import domReady from '@wordpress/dom-ready';

domReady(() => {
  const container = document.querySelectorAll('.cards-group__container');
  if (container) {
    container.forEach((element) => {
      if (element.children.length < 2) {
        element.classList.add('cards-group__one');
      } else {
        element.classList.remove('cards-group__one');
      }
    });
  }
});
